import {awaitForm} from '@/common/http'

export default class ProfileModel {
  static buildProfile(myId) {
    if(myId==null || myId==undefined){
      myId = 0
    }
    const res = awaitForm(`/api/launch/queryProfile`, {
      'myId': myId,
    })
    return res
  }
}